<ngb-accordion activeIds="ngb-panel-0" closeOthers="true">

  <ngb-panel  *ngFor="let serviceGroup of serviceGroupings">
 
      <ng-template ngbPanelTitle>
        <b>{{serviceGroup.categoryName}}</b>
      </ng-template>

      <ng-template ngbPanelContent>
        <div class="cardBody" *ngFor="let category of serviceGroup.categories">
          <h5>{{category.title}}</h5>
          <p>{{category.description}}</p>

          <a [href]="category.learnMore" target="_blank">
            Learn More
          </a>
          <br>
        </div>
      </ng-template> 
   
  </ngb-panel>
  
</ngb-accordion>

